import API from '../restservice/api.instance';

export const getToken = async () => {
  const token = await window.grecaptcha.enterprise.getResponse();
  // console.log('getToken', token);
  return token;
};

export const loadReCaptcha = (siteKey) => {
  const script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/enterprise.js?hl=pt-BR';
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  // const recaptchaInterval = setInterval(() => {
  //   if (!window.grecaptcha || !window.grecaptcha.enterprise.execute) {
  //     return;
  //   }
  //   clearInterval(recaptchaInterval);

  //   const widgetId = window.grecaptcha.enterprise.render(
  //     document.getElementById('widgetLogin'),
  //     {
  //       sitekey: siteKey,
  //       action: 'LOGIN'
  //     }
  //   );
  //   window.grecaptcha.enterprise.reset(widgetId);
  // });
};

export const validateRecaptcha = async (token) => {
  // console.log('token', token);
  const { data } = await API.get(
    `/google_captcha/validate_token?response=${token}`
  );
  return data;
};
